import * as React from 'react';

import Gmail from 'assets/images/gmail.png';
import Outlook from 'assets/images/outlook.png';

type Provider = 'outlook' | 'gmail';

interface EmailDescriptor {
  name: string;
  icon: string;
  url: string;
}

const lookup: Record<Provider, EmailDescriptor> = {
  outlook: {
    name: 'Outlook',
    icon: Outlook,
    url: 'https://outlook.live.com/mail/0/inbox',
  },
  gmail: {
    name: 'Gmail',
    icon: Gmail,
    url: 'https://mail.google.com/mail/u/0/',
  },
};

interface Props {
  provider: Provider;
}

/**
 * Abstraction for rendering a button that opens the desired email client
 * @param props
 * @returns
 */
export const Email: React.FC<Props> = (props) => {
  const { provider } = props;
  const descriptor = lookup[provider];

  return (
    <a
      href={descriptor.url}
      target="_blank"
      rel="noreferrer"
      className="p-4 flex space-x-2 items-center"
    >
      <img src={descriptor.icon} alt={descriptor.name} className="w-6" />
      <div>Open {descriptor.name}</div>
    </a>
  );
};
Email.displayName = 'EmailConfirmation.Email';
